module.exports = [{
      plugin: require('/Users/jesse/Development/zipline/marketing-website/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-113698087-3"},
    },{
      plugin: require('/Users/jesse/Development/zipline/marketing-website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
